module.exports = __webpack_public_path__ + "media/category_icons/Endocrinology-3cd5922f.svg";